<template>
  <section class="trusted-partners-section">
    <div class="container">
      <div class="support-badge">Our Support</div>

      <h2 class="title">Trusted by Banks & Corporates</h2>
      <p class="subtitle">
        Used by Financial Institutions. Recognized by Global Trade Bodies.
      </p>

      <div class="partners-grid">
        <div class="partner-item">
          <img
            class="informed-icon"
            alt=""
            :src="getCDNlink('assets/new-assets/Cyberport-Logo.webp')"
          />
          <h3 class="partner-name">
            Cyberport, wholly owned by the Hong Kong SAR Government
          </h3>
        </div>

        <div class="partner-item">
          <img
            class="informed-icon"
            alt=""
            :src="getCDNlink('assets/new-assets/HKCCMA-Logo.webp')"
          />
          <h3 class="partner-name">
            Hong Kong Credit and Collection Management Association (HKCCMA)
          </h3>
        </div>

        <div class="partner-item">
          <img
            class="informed-icon biia"
            alt=""
            :src="getCDNlink('assets/new-assets/BIIA-Logo.webp')"
          />
          <h3 class="partner-name">
            Business Information Industry Association
          </h3>
        </div>

        <div class="partner-item">
          <img
            class="informed-icon"
            alt=""
            :src="getCDNlink('assets/new-assets/ITFA-Logo.webp')"
          />
          <h3 class="partner-name">
            International Trade & Forfaiting Association
          </h3>
        </div>
      </div>

      <!-- Cards Carousel -->
      <div class="cards-carousel">
        <button
          class="carousel-arrow left"
          @click="prevSlide"
          :disabled="isPrevDisabled"
          aria-label="Previous cards"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>

        <!-- Carousel Track -->
        <div class="carousel-viewport">
          <div
            class="carousel-track"
            :style="{
              transform: `translateX(-${currentSlidePercentage}%)`,
              transition: isTransitioning
                ? 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
                : 'none',
            }"
          >
            <div
              v-for="(testimonial, index) in testimonials"
              :key="`testimonial-${index}`"
              class="card"
            >
              <p class="testimonial-text">{{ testimonial.text }}</p>
              <div class="testimonial-author">
                <p class="author-company">{{ testimonial.authorCompany }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Arrow -->
        <button
          class="carousel-arrow right"
          @click="nextSlide"
          :disabled="isNextDisabled"
          aria-label="Next cards"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import config from "@/config";

export default {
  name: "trustedPartners",
  data() {
    return {
      testimonials: [
        {
          text: "We have been working with Credence for the past 2–3 years, and they have consistently proven to be a reliable and professional partner in our credit risk assessment process. Their comprehensive credit rating reports have been instrumental in helping us evaluate the financial strength, creditworthiness, and legal standing of our existing and potential customers.",
          authorTitle: "Representative",
          authorCompany:
            "Business Development Team, Atul Middle East FZ-LLC (part of Atul Ltd, India)",
        },
        {
          text: "The insights provided by Credence have enabled us to make informed decisions when setting credit limits and managing risk. Their attention to detail, timely delivery, and clear analysis have added significant value to our internal evaluation processes. We truly appreciate the support and expertise that Credence brings and would highly recommend their services to any organization looking for a dependable credit assessment partner.",
          authorTitle: "Representative",
          authorCompany:
            "Business Development Team, Atul Middle East FZ-LLC (part of Atul Ltd, India)",
        },
        {
          text: "Credence intelligence on trade patterns and HSN codes has been invaluable in our due diligence efforts, allowing us to verify information quickly and confidently.",
          authorTitle: "Representative",
          authorCompany: "SAVP & Unit Head BRAC BANK LTD, Bangladesh",
        },
        {
          text: "Thanks to Credence due diligence reports and international trade intelligence, we are able to identify potential risks for our clients. The actual trade data also provided us with valuable insights to HSN codes and trade patterns that helped us make better business decisions.",
          authorTitle: "Representative",
          authorCompany: "Dutch Bangla Bank Limited, Bangladesh",
        },
        {
          text: "Credence has provided us with invaluable insights and data for our business decisions. Their fresh and relevant data has helped us to stay ahead of the curve and make informed decisions especially for new customer onboarding and understanding the international transactional trade.",
          authorTitle: "Representative",
          authorCompany: "CEO, Brockport Financial Services Limited, Canada",
        },
      ],
      currentSlide: 0,
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1200,
      isTransitioning: false,
    };
  },
  computed: {
    cardsPerView() {
      if (this.windowWidth >= 1024) return 3;
      if (this.windowWidth >= 768) return 2;
      return 1;
    },
    totalSlides() {
      return Math.max(0, this.testimonials.length - this.cardsPerView + 1);
    },
    currentSlidePercentage() {
      const cardWidth = 100 / this.cardsPerView;
      return cardWidth * this.currentSlide;
    },
    isPrevDisabled() {
      return this.currentSlide <= 0;
    },
    isNextDisabled() {
      return this.currentSlide >= this.totalSlides - 1;
    },
  },
  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }
      return `${baseUrl}${fileKey}`;
    },
    nextSlide() {
      if (!this.isNextDisabled && !this.isTransitioning) {
        this.isTransitioning = true;
        this.currentSlide++;

        // Reset transition flag after animation completes
        setTimeout(() => {
          this.isTransitioning = false;
        }, 600);
      }
    },
    prevSlide() {
      if (!this.isPrevDisabled && !this.isTransitioning) {
        this.isTransitioning = true;
        this.currentSlide--;

        // Reset transition flag after animation completes
        setTimeout(() => {
          this.isTransitioning = false;
        }, 600);
      }
    },
    goToSlide(index) {
      if (index !== this.currentSlide && !this.isTransitioning) {
        this.isTransitioning = true;
        this.currentSlide = index;

        // Reset transition flag after animation completes
        setTimeout(() => {
          this.isTransitioning = false;
        }, 600);
      }
    },
    handleResize() {
      const oldCardsPerView = this.cardsPerView;
      this.windowWidth = window.innerWidth;

      // Adjust current slide if cards per view changed
      if (oldCardsPerView !== this.cardsPerView) {
        const currentPage = Math.floor(this.currentSlide / oldCardsPerView);
        this.currentSlide = Math.min(currentPage, this.totalSlides - 1);
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.trusted-partners-section {
  width: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 80px 140px;
  box-sizing: border-box;
  gap: 55px;
  text-align: center;
  font-size: 48px;
  color: #1c1c1c;
  font-family: Figtree;
}

.container {
  margin: 0;
  width: -webkit-fill-available;
}

.support-badge {
  display: inline-block;
  padding: 0.5rem 1.5rem;
  background-color: #ffffff;
  color: #C94374;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid #C94374;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
}

.title {
  color: #1e3a8a;
  font-size: 48px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 0.75rem;
}

.subtitle {
  color: #1c1c1c;
  font-size: 24px;
  text-align: center;
  margin: 0 0 3.5rem;
  font-style: normal;
}

/* Partners Grid */
.partners-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  width: 100%;
  margin-bottom: 3rem;
}

.partner-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
}

.informed-icon {
  position: relative;
  max-height: 100%;
  object-fit: cover;
  width: 60%;
}

.partner-name {
  font-size: 18px;
  font-weight: 600;
  color: #1c1c1c;
  margin: 0;
}

/* Carousel */
.cards-carousel {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.carousel-viewport {
  flex: 1;
  overflow: hidden;
  border-radius: 1rem;
}

.carousel-track {
  display: flex;
  will-change: transform;
  backface-visibility: hidden;
  perspective: 1000px;
}

/* .card {
  flex: 0 0 calc(100% / 3 - 1rem);
  padding: 0 0.5rem;
  box-sizing: border-box;
  transform: translateZ(0);
}

.card > * {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 21px;
  text-align: left;
  font-size: 18px;
  color: #1c1c1c;
} */

/* Apply styles directly to card since we removed the wrapper */
.card {
  position: relative;
  box-shadow: 0px 1px 7.7px 2px #22409647;
  border-radius: 16px;
  background: linear-gradient(121.3deg, #fff, #e0f5ff);
  border: 1px solid rgba(1, 114, 244, 0.2);
  box-sizing: border-box;
  display: flex;
  padding: 21px;
  text-align: left;
  font-size: 18px;
  color: #1c1c1c;
  margin: 0.5rem;
  font-family: Figtree;
  width: calc(33.333% - 1rem);
  background-color: #ffffff;
  border-radius: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  cursor: pointer;
}

.testimonial-text {
  color: #1c1c1c;
  font-size: 16px;
  line-height: 1.6;
  margin: 0 0 0.5rem;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.testimonial-author {
  margin-top: auto;
}

.author-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1c1c1c;
  margin: 0 0 0.25rem;
}

.author-company {
  font-size: 0.8125rem;
  color: #6b7280;
  margin: 0;
  font-weight: 600;
}

/* Arrow Styling */
.carousel-arrow {
  background-color: #ffffff;
  border: 2px solid #e5e7eb;
  color: #1e3a8a;
  cursor: pointer;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.carousel-arrow:hover:not(:disabled) {
  background-color: #C94374;
  color: #ffffff;
  border-color: #C94374;
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(253, 76, 140, 0.3);
}

.carousel-arrow:active {
  transform: scale(0.95);
}

.carousel-arrow:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
}

.carousel-arrow:disabled:hover {
  background-color: #ffffff;
  color: #1e3a8a;
  border-color: #e5e7eb;
  transform: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Carousel Indicators */
.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 2rem;
}

.indicator-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #e5e7eb;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator-dot:hover {
  background-color: #cbd5e1;
  transform: scale(1.1);
}

.indicator-dot.active {
  background-color: #1e3a8a;
  transform: scale(1.2);
}

/* Responsive styles */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2.5rem;
  }

  .title {
    font-size: 2.25rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .card {
    width: calc(50% - 1rem);
  }

  .carousel-viewport {
    max-width: calc(100% - 120px);
  }

  .carousel-arrow {
    width: 48px;
    height: 48px;
    padding: 0.75rem;
  }
}

@media (max-width: 767px) {
  .trusted-partners-section {
    padding: 45px 40px;
  }

  .title {
    font-size: 36px;
  }

  .testimonial-text {
    font-size: 16px;
  }

  .subtitle {
    font-size: 16px;
    font-style: normal;
  }

  .partner-name {
    font-size: 16px;
  }

  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  .cards-carousel {
    gap: 1rem;
  }
  .card {
    width: 100%;
    margin: 0;
    border: 1px solid #f1e1e6;
    box-shadow:none;
  }
  .carousel-viewport {
    max-width: calc(100% - 80px);
  }

  .carousel-arrow {
    width: 44px;
    height: 44px;
    padding: 0.625rem;
  }

  .carousel-arrow svg {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 480px) {
  .trusted-partners-section {
    padding: 25px;
  }

  .carousel-arrow {
    width: 35px;
    height: 35px;
  }

  .subtitle {
    font-style: normal;
  }

  .partner-name {
    font-size: 16px;
  }

  .support-badge {
    padding: 0.375rem 1.25rem;
  }

  .partners-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .cards-carousel {
    gap: 0.45rem;
  }

  .informed-icon {
    width: 40%;
  }

  .biia {
    width: 30% !important;
  }

  .carousel-arrow svg {
    width: 18px;
    height: 18px;
  }

  .card {
    margin: 0;
    /* min-height: 250px; */
    /* height: auto; */
    padding: 10px;
    box-shadow: none;
    width: 100%;
  }
  .card > * {
    padding: 0;
  }
  .testimonial-text {
    font-size: 14px;
    padding: 0;
  }
}

/* Performance optimizations */
.carousel-track * {
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* Smooth scrolling for better performance */
@media (prefers-reduced-motion: no-preference) {
  .carousel-track {
    scroll-behavior: smooth;
  }
}
</style>
